export default "__VITE_PUBLIC_ASSET__e82a3ab4__"